module.exports = __webpack_public_path__ + "media/images/pc/stores/shinjuku/shinjuku_concept_04-fb7c5066c1a305880a8b12bbe12c93fa.jpg";